import { CommonModule } from '@angular/common';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, type OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import type { Connection1cConsoleFormInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c-console/connection-1c-console-form.dto';
import { BasisAccessService } from '@zaoblako/web/core/models/enums/access-rules/basis/basis-access.service';
import { Integration1cService } from '@zaoblako/web/core/services/integration/integration1c.service';
import { InputTextComponent } from '@zaoblako/web/shared/dumbs/input-text/input-text.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { JoinPipe } from '@zaoblako/web/shared/pipes/join.pipe';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { InputTextareaModule } from 'primeng/inputtextarea';

@Component({
  selector: 'crm-connection1c-console-modal',
  standalone: true,
  imports: [
    CommonModule,
    InputTextComponent,
    JoinPipe,
    FormsModule,
    InputTextareaModule,
    ButtonComponent,
    SpinnerComponent,
    SingleSelectComponent
  ],
  templateUrl: './connection1c-console-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Connection1cConsoleModalComponent implements OnInit {
  public databaseId: number;
  public form: Connection1cConsoleFormInterface = {
    method: undefined,
    params: undefined
  };

  public availableMethodsLoading = false;
  public availableMethods: string[] = [];

  public result: string;
  public loading = false;

  public get canWriteCompanyErp1C() {
    return this.basisAccessService.companyRights.canWriteCompanyErp1C;
  }

  public constructor(
    private readonly integration1cService: Integration1cService,
    private readonly basisAccessService: BasisAccessService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly config: DynamicDialogConfig
  ) {
    this.databaseId = config.data.databaseId;
  }

  public ngOnInit(): void {
    this.availableMethodsLoading = true;
    this.cdRef.markForCheck();

    this.integration1cService
      .getAvailableMethods(this.databaseId)
      .subscribe({
        next: (availableMethods) => {
          this.availableMethods = availableMethods;
          this.availableMethodsLoading = false;
          this.cdRef.markForCheck();
        },
        error: () => {
          this.availableMethods = [];
          this.availableMethodsLoading = false;
          this.cdRef.markForCheck();
        }
      });
  }

  public send() {
    this.loading = true;
    this.cdRef.markForCheck();

    this.integration1cService.testConsoleExecute(this.databaseId, this.form).subscribe({
      next: (data) => {
        this.result = data.result;
        this.loading = false;
        this.cdRef.markForCheck();
      },
      error: () => {
        this.loading = false;
        this.cdRef.markForCheck();
      }
    });
  }

  public copyResult(): void {
    if (this.result) {
      navigator.clipboard.writeText(this.result).catch(console.error);
    }
  }
}
